<template>
    <div class="relative overflow-x-hidden">
        <jet-authentication-card>
            <template #logo>
                <jet-authentication-card-logo />

                <h1
                    class="mt-[26px] text-center text-[26px] font-semibold tracking-[-0.1px] text-iron-900"
                >
                    {{ $t("auth.register.create_account") }}
                </h1>
                <p class="text-center text-sm font-medium text-iron-500">
                    {{ $t("auth.register.start_with_bookings") }}
                </p>
            </template>

            <jet-validation-errors class="mb-4" />

            <form @submit.prevent="submit">
                <div>
                    <jet-input
                        id="name"
                        v-model="form.name"
                        type="text"
                        class="block w-full"
                        required
                        autofocus
                        autocomplete="name"
                        :placeholder="$t('auth.register.name')"
                    />
                </div>

                <div class="mt-5">
                    <jet-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="block w-full"
                        required
                        :placeholder="$t('auth.register.email')"
                    />
                </div>

                <div class="mt-5">
                    <jet-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="block w-full"
                        required
                        autocomplete="new-password"
                        :placeholder="$t('auth.register.password')"
                    />
                </div>

                <div class="mt-5">
                    <jet-input
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        class="block w-full"
                        required
                        autocomplete="new-password"
                        :placeholder="$t('auth.register.confirm_password')"
                    />
                </div>

                <div
                    v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature"
                    class="mt-4"
                >
                    <jet-label for="terms">
                        <div class="flex items-center">
                            <jet-checkbox
                                id="terms"
                                v-model:checked="form.terms"
                                name="terms"
                            />

                            <div class="ml-2">
                                {{ $t("auth.register.agree_with") }}
                                <a
                                    target="_blank"
                                    :href="
                                        route('terms.show') +
                                        ($page.props.locale !== 'cs-CZ'
                                            ? ''
                                            : '?locale=cs-CZ')
                                    "
                                    class="text-sm text-iron-600 underline hover:text-iron-900"
                                    >{{ $t("auth.register.terms") }}</a
                                >
                                {{ $t("and") }}
                                <a
                                    target="_blank"
                                    :href="
                                        route('policy.show') +
                                        ($page.props.locale !== 'cs-CZ'
                                            ? ''
                                            : '?locale=cs-CZ')
                                    "
                                    class="text-sm text-iron-600 underline hover:text-iron-900"
                                    >{{ $t("auth.register.privacy") }}</a
                                >
                            </div>
                        </div>
                    </jet-label>
                </div>

                <div class="mt-10 flex items-center justify-end">
                    <ThemedButton class="w-full">
                        {{ $t("auth.register.register") }}
                    </ThemedButton>
                </div>
            </form>

            <SSOSignIn
                :register="true"
                :locale="$page.props.locale !== 'cs-CZ' ? 'en-US' : 'cs-CZ'"
            />

            <template #under>
                <p class="mt-8 text-center text-sm text-iron-500">
                    {{ $t("auth.register.already_registered") }}
                    <!-- space -->
                    <a
                        :href="
                            $page.props.locale !== 'cs-CZ'
                                ? '/login'
                                : '/login?locale=cs-CZ'
                        "
                        class="font-semibold leading-6 text-z-primary-600 hover:opacity-75"
                        >{{ $t("auth.register.sign_in_here") }}</a
                    >
                </p>
            </template>
        </jet-authentication-card>
    </div>
</template>

<script setup lang="ts">
import JetAuthenticationCard from "../../Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "../../Jetstream/AuthenticationCardLogo.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetCheckbox from "../../Jetstream/Checkbox.vue";
import JetLabel from "../../Jetstream/Label.vue";
import JetValidationErrors from "../../Jetstream/ValidationErrors.vue";
import SSOSignIn from "./components/SSOSignIn.vue";
import { router, useForm, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useUrlSearchParams } from "@vueuse/core";
import ThemedButton from "../ZapTime/App/Atomic/ThemedButton.vue";
import { useAffiliate } from "@/composables/useAffiliate";

const params = useUrlSearchParams("history");

const form = useForm({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    country: "CZ",
    terms: true,
    locale: params.locale !== "cs-CZ" ? "en-US" : "cs-CZ",
});

useAffiliate();

function submit() {
    form.post(route("register"), {
        onFinish: () => form.reset("password", "password_confirmation"),
        onSuccess: () => router.visit(route("verification.notice")),
    });
}
</script>
